module.exports = __webpack_public_path__ + "img/near_logo_stack.62168e69.svg";